"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _regeneratorValues2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regeneratorValues.js"));
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _lodash = _interopRequireDefault(require("lodash"));
var _elDragDialog = _interopRequireDefault(require("@/directive/el-drag-dialog"));
var _index = _interopRequireDefault(require("@/components/UploadExcel/index.vue"));
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _loop2 = require("@/api/loop");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import moment from 'moment-timezone'
// import Tinymce from '@/components/Tinymce'
// import QrcodeVue from 'qrcode.vue'
// import { truncate } from '@/filters'
// const defaultValue = []
var _default = exports.default = {
  name: 'LoopEnrollment',
  components: {
    UploadExcelComponent: _index.default
  },
  directives: {
    elDragDialog: _elDragDialog.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      fullscreenloading: false,
      loop: null,
      myLoopTeams: [],
      isShowResult: false,
      noOfSuccess: 0,
      noOfFail: 0,
      tableData: [],
      tableHeader: [],
      smallDrop: 'smallDrop',
      loading: false
    };
  },
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.getLoop();
          case 1:
            _context.n = 2;
            return _this.getLoopParticipants();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    handleDrag: function handleDrag() {
      // this.$refs.select.blur()
    },
    openDialog: function openDialog() {
      this.tableData = [];
      this.tableHeader = [];
      this.isShowResult = false;
      this.dialogVisible = true;
    },
    handleSuccess: function handleSuccess(_ref) {
      var results = _ref.results,
        header = _ref.header;
      // console.log('upload excel file-result', results)
      // console.log('upload excel file-header', results)
      var loopId = this.loop.id;
      console.info("loop id:" + loopId);
      this.tableData = _lodash.default.map(results, function (r) {
        return {
          loopId: _lodash.default.trim(loopId),
          email: _lodash.default.trim(_lodash.default.toLower(r.email)),
          givenName: _lodash.default.trim(r.givenName),
          familyName: _lodash.default.trim(r.surname),
          orgName: _lodash.default.trim(r.orgName),
          jobTitle: _lodash.default.trim(r.jobTitle)
        };
      });
      this.tableHeader = header;
    },
    beforeUpload: function beforeUpload(file) {
      // console.log('upload excel file', file)
      return true;
    },
    doUpload: function doUpload() {
      if (this.tableData.length <= 0) {
        var msg = this.$i18n.t('otrTraining.msgEmptyRecord');
        (0, _log.displayPopupMessage)(msg, 'error');
        return false;
      }
      var loopId = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      var oEmail = (0, _cookie.getCookie)('EMAIL');
      this.fullscreenloading = true;
      this.isShowResult = false;
      this.noOfFail = 0;
      this.noOfSuccess = 0;
      this.createAccount();
      (0, _ga.writeGaEvent)(this, 'Loop', "".concat(_lifehikesInitData.userEvent.loop.uploadParticipant), oEmail, "Loop Id: ".concat(loopId));
    },
    EmailFormatErrorStyle: function EmailFormatErrorStyle(email) {
      var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return !re.test(email) && email !== '' ? 'error' : '';
    },
    createAccount: function createAccount() {
      var _this2 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var token, _loop, i;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              _this2.isShowResult = true;
              _loop = /*#__PURE__*/(0, _regenerator2.default)().m(function _loop(i) {
                return (0, _regenerator2.default)().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _context2.n = 1;
                      return (0, _loop2.enrollLoop)(token, _this2.tableData[i]).then(function (response) {
                        (0, _log.showDebugLog)('registerEnroll-API-OK', response.data);
                        _this2.tableData[i].result = 'Success';
                        _this2.$set(_this2.tableData, i, _this2.tableData[i]);
                        (0, _log.showDebugLog)('Table content row', i);
                        _this2.noOfSuccess += 1;
                      }).catch(function (error) {
                        // showDebugLog('registerEnroll-API-Fail', error.response)
                        var msg = typeof error.response === 'undefined' ? error.toString() : error.response.data.message;
                        _this2.noOfFail += 1;
                        _this2.tableData[i].result = 'Fail:' + msg;
                        _this2.$set(_this2.tableData, i, _this2.tableData[i]);
                        // showDebugLog('registerEnroll-API-Fail', msg)
                        (0, _log.showDebugLog)('Table content row', i);
                      });
                    case 1:
                      return _context2.a(2);
                  }
                }, _loop);
              });
              i = 0;
            case 1:
              if (!(i < _this2.tableData.length)) {
                _context3.n = 3;
                break;
              }
              return _context3.d((0, _regeneratorValues2.default)(_loop(i)), 2);
            case 2:
              i++;
              _context3.n = 1;
              break;
            case 3:
              _context3.n = 4;
              return _this2.getLoopParticipants();
            case 4:
              _this2.fullscreenloading = false;
            case 5:
              return _context3.a(2);
          }
        }, _callee2);
      }))();
    },
    getLoop: function getLoop() {
      var _this3 = this;
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      (0, _loop2.getLoopById)(token, id).then(function (response) {
        _this3.loop = response.data;
        _this3.loading = false;
      }).catch(function (error) {
        (0, _log.showDebugLog)('loop-getLoopById-error', error);
        _this3.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    getLoopParticipants: function getLoopParticipants() {
      var _this4 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var token, id;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              id = typeof _this4.$route.params.id === 'undefined' ? '' : _this4.$route.params.id;
              _context4.n = 1;
              return (0, _loop2.getParticipant)(token, id).then(function (response) {
                _this4.myLoopTeams = response.data.rows;
              }).catch(function (error) {
                (0, _log.showDebugLog)('Loop-getParticipant-API-error', error);
                (0, _log.displayPopupMessage)(error, 'error');
              });
            case 1:
              return _context4.a(2);
          }
        }, _callee3);
      }))();
    },
    backToLoop: function backToLoop() {
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      this.$router.push("/loop/edit/".concat(id));
    }
  }
};